module.exports = __webpack_public_path__ + "static/img/abimg1.808e11c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg1.jpg
// module id = 0jso
// module chunks = 1